export default "__VITE_ASSET__DCWNwz_U__"